<template>
    <div class="user-avatar">
        <component
            :is="quickLook ? 'vx-dropdown' : 'div'"
            ref="dropdown"
            style="cursor: pointer"
            class="flex items-center"
            :align="alignQuickLook"
            :justify="justifyQuickLook"
        >
            <vx-avatar
                class="user-profile-img"
                :src="profileImage"
                :size="pixelSize"
                :alt-src="defaultImg"
                :class="{ bordered: !noBorder, shadowed: !noShadow }"
            />
            <template v-if="quickLook" slot="menu">
                <vx-card
                    :title="fullName"
                    :subtitle="staff.jobTitle"
                    no-shadow
                    no-radius
                    style="background-color: transparent"
                >
                    <staff-contact-info :staff="staff" hide-image />
                </vx-card>
            </template>
        </component>
    </div>
</template>

<script>
import StaffContactInfo from './Card/StaffContactInfo.vue'

export default {
    name: 'user-avatar',
    components: { StaffContactInfo },
    props: {
        staff: {
            type: Object,
            required: true
        },
        noBorder: {
            type: Boolean
        },
        quickLook: {
            type: Boolean
        },
        size: {
            type: [String, Number],
            default: '90px'
        },
        noShadow: {
            type: Boolean
        },
        alignQuickLook: {
            type: String
        },
        justifyQuickLook: {
            type: String
        }
    },
    data() {
        return {}
    },
    computed: {
        pixelSize() {
            if (typeof this.size === 'string') {
                return this.size
            }
            return `${this.size}px`
        },
        fullName() {
            return this.loading ? 'Loading...' : `${this.staff.firstName} ${this.staff.lastName}`
        },
        profileImage() {
            if (this.staff.profileImageId && this.isActiveStaff) {
                return this.$api.resources.getThumbnailUrl(this.staff.profileImageId)
            }
            return this.defaultImg
        },
        defaultImg() {
            return require('@/assets/images/team-placeholder.png')
        },
        isActiveStaff() {
            return !!this.staff.isActiveStaff
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.user-profile-img {
    &.shadowed {
        box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.3);
    }
    &.bordered {
        border: 0.3rem solid #fff;
    }
}
</style>
